(() => {
  window.HolyQuickProgress = {
    mount(container, tiers) {
      const root = container.querySelector('.bulk-progress-wrapper');
      if (!root) return { update() {} };
      let previous = null, previousQuantity = null, timer, countTimer;
      return {
        update(quantity, formattedSavings, silent) {
          const level = tiers.filter(t => quantity >= t.qty).length;
          root.dataset.level = String(level);
          if (!silent && previousQuantity !== null && quantity > previousQuantity) {
            clearTimeout(countTimer);
            root.classList.remove('is-quantity-up');
            void root.offsetWidth;
            root.classList.add('is-quantity-up');
            countTimer = setTimeout(() => root.classList.remove('is-quantity-up'), 500);
          }
          previousQuantity = quantity;
          if (!silent && previous !== null && level > previous) {
            clearTimeout(timer);
            root.classList.remove('is-level-up');
            void root.offsetWidth;
            root.classList.add('is-level-up');
            timer = setTimeout(() => root.classList.remove('is-level-up'), 1000);
          }
          previous = level;
        }
      };
    }
  };
})();
